// app/src/index.js

$(function () {
   console.log('Welcome to HVAT - Index.');
});

// ============================================================================
// Controls handlers
// ============================================================================
